$(window).scroll(function() {
	productnav();
});

function productnav(){
	var wwidth = window.innerWidth;
	if(wwidth > 760) {
		if($(window).scrollTop() >= 50) {
			$(".product-nav").addClass("fixedNav");
		} else {
			$(".product-nav").removeClass("fixedNav");
		}
	}
}



// WEBPACK FOOTER //
// ./E:/airwheel.net/Content/js/product-nav.js